import React from 'react';
import { Button, IButtonProps } from '~/UIKit';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material';
import { NeoBaseTheme } from '~/Config/theme.config';

const theme = createTheme({
  ...NeoBaseTheme,
  palette: {
    primary: {
      50: '#ED2F2F',
      100: '#ED2F2F',
      200: '#ED2F2F',
      300: '#ED2F2F',
      400: '#ED2F2F',
      500: '#ED2F2F',
      600: '#ED2F2F',
      700: '#ED2F2F',
      800: '#ED2F2F',
      900: '#ED2F2F',
      A100: '#ED2F2F',
      A200: '#ED2F2F',
      A400: '#ED2F2F',
      A700: '#ED2F2F',
    },
  },
});

export const ErrorButton = (props: IButtonProps) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <Button {...props} />
    </ThemeProvider>
  </StyledEngineProvider>
);
